'use client';

import classnames from 'classnames';

import { Button } from '../../button';
import { getSelectOptionButtonVariant } from '../layout/SelectOption';
import type { ButtonGroupProps } from './ButtonGroup.types';

import styles from './ButtonGroup.module.scss';

export function ButtonGroup({
  style,
  className,
  onSelect,
  onDeselect,
  options,
  disabled = false,
  error = false,
  warning = false,
  size = 'sm',
  display = 'block',
  label,
  testId = 'ui-button-group',
}: ButtonGroupProps) {
  return (
    <div
      style={style}
      className={classnames(
        styles['button-group'],
        styles[`button-group--${display}`],
        className,
      )}
      role="group"
      aria-label={label}
      data-testid={testId}
    >
      {options.map((option, index) => (
        <Button
          key={option.value}
          className={styles[`button--${display}`]}
          disabled={disabled || option.disabled}
          size={size}
          aria-pressed={option.selected ?? false}
          prefixIcon={option.icon}
          data-testid={`${testId}_item_${index}`}
          variant={getSelectOptionButtonVariant(option, error, warning)}
          onClick={() =>
            option.selected && onDeselect
              ? onDeselect()
              : onSelect(option.value)
          }
        >
          {option.customLabel ?? option.label}
        </Button>
      ))}
    </div>
  );
}
